/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: '日期',
  time: '时间',
  hours: '{howMany} 小时',
  minutes: '{howMany} 分钟',
  today: '今天',
  duration: '时长',
  topic: '会议标题',
  voIPOnly: '仅网络音频',
  telephonyOnly: '仅电话',
  both: '电话和网络音频',
  thirdParty: '第三方音频',
  meetingId: '会议 ID',
  password: '密码',
  video: '视频',
  audio: '音频',
  scheduleFor: '代表以下人员安排时间：',
  [ASSISTED_USERS_MYSELF]: '我自己',
  meetingOptions: '会议选项',
  meetingSettings: '会议设置',
  rcMeetingSettings: '视频会议设置',
  audioOptions: '音频选项',
  recurringMeeting: '定期会议',
  recurringNote: '注意：选择“定期”时方可启用此项',
  joinBeforeHost: '允许参与者在主持人之前加入',
  turnOffCamera: '关闭参与者的摄像头',
  turnOffHostCamera: '加入会议时关闭主持人的摄像头',
  requirePassword: '需要输入密码',
  enterPassword: '输入密码',
  setPassword: '设置密码 *',
  passwordEmptyError: '会议密码为必填项',
  rcmPasswordInvalidError:
    '密码必须包含 1 到 10 个字符和数字，且不能使用除 @、* 或 - 以外的特殊符号',
  rcmPasswordHintText:
    '密码应包含 1 到 10 个字符和数字，且不能使用除 @、* 或 - 以外的特殊符号',
  usePersonalMeetingId: '使用个人会议 ID',
  pmiChangeConfirm: '要对个人会议进行更改， ',
  changePmiSettings: '更改 PMI 设置',
  pmiSettingChangeAlert:
    '您更改设置并安排会议时间后，使用个人会议 ID 的所有会议都会改为使用最新设置。',
  lockedTooltip: '此设置由公司管理员管理',
  when: '时间',
  recurringDescribe: '请记得检查通过日历向参与者发送的邀请中是否存在重复。',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
